import React, {useEffect, useState} from 'react';
import {Wrap, WrapItem} from '@chakra-ui/react';

import Card from '../../components/Maintenance/IconCard';
import ErrorHelper from '../../service/ErrorHelper';
import LoadingWheel from '../../components/General/LoadingWheel';
import {Report} from '../../service/Urls';
import {get} from '../../service/ApiService';
import {getReportCard} from '../../helpers/ReportCardDictionary';
import {getUserRole} from '../../helpers/localStorage';
import Roles from '../../constants/Roles';
import {RiFolderZipFill} from 'react-icons/ri';

const Reports = props => {
  // static displayName = FetchData.name;
  const [isLoading, setLoading] = useState(true);
  const [toast, setToast] = useState({});
  const [reports, setReports] = useState({});

  const roles = getUserRole();

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async id => {
    const response = await get(Report.LIST_CARDS);
    setToast(response);

    if (!response.error) {
      const reportCards = response.data.map(screen => {
        screen = getReportCard(screen.code);
        return screen;
      });
      setReports(reportCards);
    }

    // Turn off the loading wheel since we're done loading
    setLoading(false);
  };
  // const reportScreens = [
  //   {Name: 'Survey Reports', Icon: FaRegListAlt, RouteName: 'survey'},
  //   {Name: 'Client Reports', Icon: FaUsers, RouteName: 'client'},
  //   {Name: 'Batch Print', Icon: FaLayerGroup, RouteName: 'batch'},
  // ];
  return (
    <>
      {isLoading ? (
        <LoadingWheel />
      ) : (
        <Wrap mt={'10'}>
          {/* {reportScreens.map((screen, idx) => {
            return (
              <WrapItem key={idx}>
                <Card name={screen.Name} icon={screen.Icon} route={'/reports/' + screen.RouteName} />
              </WrapItem>
            );
          })} */}
          {reports &&
            reports.map((screen, idx) => {
              return (
                <WrapItem key={idx}>
                  <Card name={screen.name} icon={screen.icon} route={'/reports/' + screen.route} />
                </WrapItem>
              );
            })}
          {roles?.includes(Roles.ADMIN) && (
            <WrapItem>
              <Card name={'Client Reports for Sales Reps'} icon={RiFolderZipFill} route={'/reports/salesclient'} />
            </WrapItem>
          )}
          <ErrorHelper toastResponse={toast} />
        </Wrap>
      )}
    </>
  );
};

export default Reports;
